import {
  styled,
  Dialog,
  dialogClasses,
  IconButton,
  DialogContent,
} from '@mui/material';

export const DialogCreateTemplateByRouteContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: 600,
    width: '100%',
  },
});

export const DialogCreateTemplateByRouteTitle = styled('div')(({ theme }) => ({
  flex: 'none',
  padding: theme.spacing(2, 3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const DialogCreateTemplateByRouteTitleCloseIcon = styled(IconButton)(
  ({ theme }) => ({
    color: theme.palette.grey[500],
  }),
);

export const DialogCreateTemplateByRouteContent = styled(DialogContent)(
  ({ theme }) => ({
    paddingBottom: theme.spacing(4),
  }),
);
